module.exports = __webpack_public_path__ + "img/pattern1.778962e.svg";